export default __webpack_public_path__ + "static/media/timer2.08fc798e.png";